import { SERVICES_API } from '../constants/api';
import {  GET_PROXY } from '../functions/superagentSending';

const initialState = {
    loading: true,
    postLoading: false,
    categoryLoading: false,
    meta: {},
    data: {
    },
    error: '',
};

const FETCH_SERVICES_REQUEST = 'FETCH_SERVICES_REQUEST';
const FETCH_SERVICES_POST_REQUEST = 'FETCH_SERVICES_POST_REQUEST';
const FETCH_SERVICES_CATEGORY_REQUEST = 'FETCH_SERVICES_CATEGORY_REQUEST';
const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';
const FETCH_SERVICES_FAILURE = 'FETCH_SERVICES_FAILURE';

const fetchServicesRequest = () => ({
    type: FETCH_SERVICES_REQUEST,
});
const fetchServicesPostRequest = () => ({
    type: FETCH_SERVICES_POST_REQUEST,
});

const fetchServicesCategoryRequest = () => ({
    type: FETCH_SERVICES_CATEGORY_REQUEST,
});

const fetchServicesSuccess = (data) => ({
    type: FETCH_SERVICES_SUCCESS,
    payload: data,
});

const fetchServicesFailure = (error) => ({
    type: FETCH_SERVICES_FAILURE,
    payload: error,
});

const ServicesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_SERVICES_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_SERVICES_POST_REQUEST:
            return {
                ...state,
                postLoading: true,
            };
        case FETCH_SERVICES_CATEGORY_REQUEST:
            return {
                ...state,
                categoryLoading: true,
            };
        case FETCH_SERVICES_SUCCESS:
            return {
                ...state,
                loading: false,
                postLoading: false,
                categoryLoading: false,
                data: {
                    ...payload?.data,
                    shops: [
                        ...(payload?.meta?.current_page > 1 ? state?.data?.shops : []),
                        ...(payload?.data?.shops || []),
                    ]
                },
                meta: payload.meta,
                error: '',
            };
        case FETCH_SERVICES_FAILURE:
            return {
                meta: {},
                loading: false,
                postLoading: false,
                categoryLoading: false,
                data: {},
                error: payload,
            };
        default:
            return state;
    }
};

export const FETCH_SERVICES_REDUCER = (name = '', categories = '', promotions = '', lettersFilter = '', page = '', callback = () => { }) => {
    return (dispatch) => {
        if (page && page === 1)
            dispatch(fetchServicesCategoryRequest())
        else if (page && page > 1)
            dispatch(fetchServicesPostRequest());
        else
            dispatch(fetchServicesRequest());

        GET_PROXY(`${SERVICES_API}?page=${page}&filter[categories]=${categories}&filter[lettersFilter]=${lettersFilter}&filter[promotions]=${promotions}&filter[name]=${name}`,
            (success) => {
                callback()
                dispatch(fetchServicesSuccess(success));
            },
            (error) => {
                dispatch(fetchServicesFailure(error));
                dispatch(fetchServicesFailure(''));
            })
    };
};

export default ServicesReducer;
